import hljs from "highlight.js"

export default {
    mounted() {
        let codeBlock = this.el.querySelector('pre code')
        if (codeBlock) {
          hljs.highlightElement(codeBlock)
        }
    },
    updated() {
        let codeBlock = this.el.querySelector('pre code')
        if (codeBlock) {
          hljs.highlightElement(codeBlock)
        }
    },
}

